<section class="search-section">
  <form autocomplete="off" (ngSubmit)="buscar()" [formGroup]="formBusqueda">
    <div class="search-container">
      <p class="search-title">¿Qué estás buscando?</p>
      <div class="search-row">
        <div class="select-group">
          <div class="custom-select-wrapper" [class.open]="openedSelect === 'tipoInmueble'">
            <div class="custom-select-display" (click)="toggleTipoInmueble()">
              <div class="custom-select-text">
                <label class="custom-select-label"
                  [class.float]="!!selectedTipoInmuebleText">
                  Tipo de inmueble*
                </label>
                <span class="selected-value" *ngIf="selectedTipoInmuebleText">
                  {{ selectedTipoInmuebleText }}
                </span>
              </div>
              <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                [style.transform]="'rotate(' + tipoInmuebleRotation + 'deg)'"
                [style.transition]="'transform 0.3s ease'">
            </div>
            <ul class="custom-select-options" *ngIf="openedSelect === 'tipoInmueble'">
              <li *ngFor="let tipo of selectedItem" (click)="selectTipoInmueble(tipo)">
                {{ tipo.nombre }}
              </li>
            </ul>
          </div>

          <div class="custom-select-wrapper" [class.open]="openedSelect === 'rango'">
            <div class="custom-select-display" (click)="toggleRango()">
              <div class="custom-select-text">
                <label class="custom-select-label" [class.float]="!!selectedRangoText">
                  Rango de precios (pesos)
                </label>
                <span class="selected-value" *ngIf="selectedRangoText">
                  {{ selectedRangoText }}
                </span>
              </div>
              <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                [style.transform]="'rotate(' + rangoRotation + 'deg)'" [style.transition]="'transform 0.3s ease'">
            </div>
            <ul class="custom-select-options" *ngIf="openedSelect === 'rango'">
              <li (click)="selectRango(1, '$0 a $500,000')">$0 a $500,000</li>
              <li (click)="selectRango(2, '$500,000 a $1,000,000')">$500,000 a $1,000,000</li>
              <li (click)="selectRango(3, '$1,000,000 a $3,000,000')">$1,000,000 a $3,000,000</li>
              <li (click)="selectRango(4, '$3,000,000 a $5,000,000')">$3,000,000 a $5,000,000</li>
              <li (click)="selectRango(5, 'Mayor a $5,000,000')">Mayor a $5,000,000</li>
            </ul>
          </div>

          <div class="custom-select-wrapper" [class.open]="openedSelect === 'estado'">
            <div class="custom-select-display" (click)="toggleEstado()">
              <div class="custom-select-text">
                <label class="custom-select-label" [class.float]="!!selectedEstadoText">
                  Estado*
                </label>
                <span class="selected-value" *ngIf="selectedEstadoText">
                  {{ selectedEstadoText }}
                </span>
              </div>
              <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                [style.transform]="'rotate(' + estadoRotation + 'deg)'" [style.transition]="'transform 0.3s ease'">
            </div>
            <ul class="custom-select-options" *ngIf="openedSelect === 'estado'">
              <li *ngFor="let estado of selectedEstado" (click)="selectEstado(estado)">
                {{ estado.nombre }}
              </li>
            </ul>
          </div>

          <div class="custom-select-wrapper" [class.open]="openedSelect === 'ciudad'">
            <div class="custom-select-display" (click)="toggleCiudad()">
              <div class="custom-select-text">
                <label class="custom-select-label" [class.float]="!!selectedCiudadText">
                  Alcaldía/Municipio
                </label>
                <span class="selected-value" *ngIf="selectedCiudadText">
                  {{ selectedCiudadText }}
                </span>
              </div>
              <img src="Inmuebles/assets/iconos/vector.svg" class="arrow"
                [style.transform]="'rotate(' + ciudadRotation + 'deg)'" [style.transition]="'transform 0.3s ease'">
            </div>
            <ul class="custom-select-options" *ngIf="openedSelect === 'ciudad'">
              <li *ngFor="let ciudad of busquedaCiudad.ciudades" (click)="selectCiudad(ciudad)">
                {{ ciudad.nombre }}
              </li>
            </ul>
          </div>
        </div>
        <div class="btn-wrapper">
          <button type="submit" (click)="buscar()" class="btn" [disabled]="formBusqueda.invalid">
            <span class="btn-text">Buscar</span>
            <img *ngIf="!formBusqueda.invalid" src="Inmuebles/assets/iconos/search_icon.svg" class="btn-icon" alt="Lupa" />
            <img *ngIf="formBusqueda.invalid" src="Inmuebles/assets/iconos/disabled_icon.svg" />
          </button>
        </div>
      </div>
    </div>
  </form>
</section>